import React from "react";
import { Row, Table } from "antd";
import { useHistory } from "react-router-dom";

import Title from "components/Title/Title";
import SummaryInfoCard from "components/SummaryInfoCard/SummaryInfoCard";

import { constructDisplayPrice } from "utils/general";
import { buildAWPersonalUri } from "utils/routes";

import { ExtraInfoText, FinancialValueText } from "./AWSummary.styles";
import Locale from "react-intl-universal";

const AWSummary = ({
  allowToAccess,
  personalInfo,
  financialInfo,
  dependentYears,
}) => {
  const history = useHistory();

  if (!allowToAccess) {
    history.push(buildAWPersonalUri());
    return null;
  }

  const dataSource = [
    {
      label: Locale.get("summary.tMonthlyIncome"),
      value: constructDisplayPrice(financialInfo.totalIncome, false),
    },
    {
      label: Locale.get("summary.tMonthlyExpense"),
      value: constructDisplayPrice(
        financialInfo.totalExpenses + financialInfo.totalMonthlyPremiums,
        false
      ),
      extraInfo: `${Locale.get(
        "summary.extraMonthlyExpense"
      )} - ${constructDisplayPrice(financialInfo.totalMonthlyPremiums, false)}`,
    },
    {
      label: Locale.get("summary.tLoanAmount"),
      value: constructDisplayPrice(financialInfo.totalLoan, false),
      extraInfo: `${Locale.get(
        "summary.extraLoanBalance"
      )} - ${constructDisplayPrice(financialInfo.totalLoanBalance, false)}`,
    },
    {
      label: Locale.get("summary.tInsurancePlan"),
      value: constructDisplayPrice(financialInfo.totalCoverages, false),
    },
    {
      label: Locale.get("summary.ideLabel"),
      value: constructDisplayPrice(financialInfo.immediateDeathAmt, false),
      extraInfo: Locale.get("summary.extraIde"),
    },
    {
      label: Locale.get("summary.rrfLabel"),
      value: constructDisplayPrice(
        financialInfo.recoverRecuperatingFund,
        false
      ),
    },
    {
      label: Locale.get("summary.minYearResponsible"),
      value: financialInfo.minYearsOfResponsibility,
      extraInfo: Locale.get("summary.extraYear"),
    },
  ];

  const columns = [
    {
      dataIndex: "label",
      key: "label",
    },
    {
      dataIndex: "value",
      key: "value",
      render: (value) => <FinancialValueText>{value}</FinancialValueText>,
    },
    {
      dataIndex: "extraInfo",
      key: "extraInfo",
      render: (value) => <ExtraInfoText>{value}</ExtraInfoText>,
    },
  ];

  return (
    <>
      <Title type="default">{Locale.get("summary.cardTitle_0")}</Title>
      <SummaryInfoCard
        name={personalInfo.name}
        age={personalInfo.age}
        dob={personalInfo.dob && personalInfo.dob.format("YYYY-MM-DD")}
        dependentYears={dependentYears}
        noOfDependentFamilyMember={personalInfo.noOfDependentFamilyMember}
        isInDetailPage={false}
      />
      <Title type="default">{Locale.get("summary.cardTitle_1")}</Title>
      <Row>
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={false}
          rowKey={(record) => record.label}
          showHeader={false}
          style={{ width: "100%" }}
        />
      </Row>
    </>
  );
};

export default AWSummary;
